import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string | string[];
  highlight?: boolean;
}
const faqData: FAQItem[] = [{
  question: "Can you buy my company although it's in debt?",
  answer: 'THE SIMPLE ANSWER IS YES. Legally you can sell your company to whoever wants to buy it for whatever price they want to pay.',
  highlight: true
}, {
  question: 'Am I responsible for the debts in the company?',
  answer: 'NO. Because we buy 100% of the shares in the company, that means we own all the liabilities in the company — leaving you free to move on.',
  highlight: true
}, {
  question: 'How does it work exactly?',
  answer: ['We buy 100% of the shares of the Ltd company, generally for £1.', "We then appoint a new set of directors who are responsible for the running of the company and the company's liabilities.", 'We also change the company address so all correspondence comes to us.']
}, {
  question: 'Will I still get letters from creditors and debt collectors?',
  answer: 'NO. As the company is no longer owned by you and as you cease to be a director, all correspondence will go to the new directors at the new address — including bailiffs.',
  highlight: true
}, {
  question: 'What happens to my business? Do you get my customers?',
  answer: 'Once we have taken over the company, we have no interest in your business. You can now carry on trading debt free.'
}, {
  question: 'Is it legal?',
  answer: "OF COURSE. It's your company to sell, even with debt. The debt will transfer to the new owners — including bounce back loans, trade creditors, and in fact all unsecured debt.",
  highlight: true
}, {
  question: 'What happens to the company once you buy it?',
  answer: ['Once we own the company, we will cease trading.', 'We will inform all creditors and discuss the various options.', 'The outcome can be varied, but ultimately if the creditors want to pursue any debts, we will put the company into liquidation.']
}, {
  question: 'What if I have a winding up petition?',
  answer: 'NO PROBLEM. We can execute a purchase within 24 hours — leaving you free to walk away from the petition.',
  highlight: true
}, {
  question: 'Can you help me fight a winding up petition?',
  answer: 'YES WE CAN. Please see our Other Services section for more information about winding up petition representation.'
}, {
  question: 'What happens to my personal guarantee?',
  answer: 'Important: We cannot help with personal guarantees. When we transfer your company to a new buyer, any personal guarantees you have signed remain your legal responsibility. Personal guarantees are contracts between you personally and the creditor — they do not transfer with the company. Even after the company transfer is complete, you will still be liable for any personal guarantees you have signed. We strongly recommend seeking independent legal advice about your personal guarantees before proceeding.'
}];
interface FAQProps {
  limit?: number;
  showAll?: boolean;
}
export const FAQ: React.FC<FAQProps> = ({
  limit,
  showAll = true
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const displayData = limit ? faqData.slice(0, limit) : faqData;
  return <div className="max-w-3xl mx-auto" data-id="element-82">
      <div className="space-y-4" data-id="element-83">
        {displayData.map((item, index) => <div key={index} className={`border rounded-lg overflow-hidden bg-white ${item.highlight ? 'border-red-200' : 'border-gray-200'}`} data-id="element-84">
            <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors" data-id="element-85">
              <span className="font-semibold text-gray-900 pr-8" data-id="element-86">
                {item.question}
              </span>
              {openIndex === index ? <ChevronUpIcon className="h-5 w-5 text-red-600 flex-shrink-0" data-id="element-87" /> : <ChevronDownIcon className="h-5 w-5 text-gray-400 flex-shrink-0" data-id="element-88" />}
            </button>
            {openIndex === index && <div className={`px-6 py-4 border-t ${item.highlight ? 'bg-red-50 border-red-100' : 'bg-gray-50 border-gray-200'}`} data-id="element-89">
                {Array.isArray(item.answer) ? <ul className="space-y-2" data-id="element-90">
                    {item.answer.map((line, i) => <li key={i} className="text-gray-700 flex items-start" data-id="element-91">
                        <span className="text-red-600 mr-2" data-id="element-92">•</span>
                        {line}
                      </li>)}
                  </ul> : <p className={`${item.highlight ? 'text-gray-800 font-medium' : 'text-gray-700'}`} data-id="element-93">
                    {item.answer}
                  </p>}
              </div>}
          </div>)}
      </div>
    </div>;
};
export { faqData };